// Google Analytics (GA4) 上報封裝
// gtag.js 於 public/index.html 載入，並已設定 send_page_view: false，
// 因此每次路由切換都需由此處手動送出 page_view。

export const GA_MEASUREMENT_ID = "G-9JJKS9GY58";

// gtag.js 為 async 載入，未就緒時靜默略過，避免阻斷渲染
const gtag = (...args) => {
  if (typeof window.gtag !== "function") return;
  window.gtag(...args);
};

// 送出一次 page_view，供 SPA 路由切換時呼叫
export const trackPageView = () => {
  gtag("event", "page_view", {
    page_path: window.location.pathname + window.location.search,
    page_location: window.location.href,
    page_title: document.title,
  });
};
